import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { serchSelect, tabulation, gmToolNewPage } from "@/mixins/index";
import { dailyRegisterList } from "@/api/dataAll/dataAll";
export default {
  name: "dailyRegistration",
  mixins: [serchSelect, tabulation, gmToolNewPage],
  data: function data() {
    return {
      tableData: [],
      paramsData: {
        page: 1,
        page_size: 10,
        device_id: "",
        user_id: "",
        role_id: ""
      },
      total: 0
    };
  },
  created: function created() {},
  methods: {
    searchClick: function searchClick(page) {
      var _this = this;

      this.tableData = [];

      if (this.value2.length > 0) {
        this.searchData.starttime = this.value2[0];
        this.searchData.endtime = this.value2[1];
      }

      this.reqLoading = true;
      this.paramsData.page = page;
      dailyRegisterList(_objectSpread(_objectSpread({}, this.searchData), this.paramsData)).then(function (res) {
        if (res.status == 200) {
          _this.tableData = res.data.data;
          _this.total = res.data.total;
        }
      }).finally(function () {
        _this.reqLoading = false;
      });
    },
    sizeChange: function sizeChange(e) {
      this.paramsData.page_size = e;
      this.searchClick(1);
    },
    exportdata: function exportdata() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var columns, params, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                columns = [{
                  label: _this2.$t('gameName'),
                  prop: 'game'
                }, {
                  label: _this2.$t('platform'),
                  prop: 'platform'
                }, {
                  label: _this2.$t('channel'),
                  prop: 'channel'
                }, {
                  label: _this2.$t('pkg'),
                  prop: 'pkg'
                }, {
                  label: _this2.$t('adChannel'),
                  prop: 'ad_channel'
                }, {
                  label: _this2.$t('adPlacement'),
                  prop: 'ad_placement'
                }, {
                  label: _this2.$t('serverId'),
                  prop: 'server_id'
                }, {
                  label: _this2.$t('deviceId'),
                  prop: 'device_id'
                }, {
                  label: _this2.$t('userId'),
                  prop: 'user_id'
                }, {
                  label: _this2.$t('roleId'),
                  prop: 'role_id'
                }, {
                  label: _this2.$t('time'),
                  prop: 'time'
                }];
                params = Object.assign({}, _this2.searchData, _this2.paramsData);
                delete params.page;
                delete params.page_size;
                _context.next = 6;
                return dailyRegisterList(params).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data.data;
                  }
                });

              case 6:
                data = _this2.tableData;

                _this2.$export.excel({
                  columns: columns,
                  data: data,
                  title: _this2.$route.meta.title
                });

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  }
};